import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {
    TextField,
    Container,
    Grid,
    CircularProgress,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Tooltip, Button, Chip, Snackbar, Alert
} from '@mui/material';
import "./CreateExpCaseComponent.css";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import LocationProps from "../../../enums/LocationProps";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import {jwtDecode} from "jwt-decode";
import CaseNotificationEnum from "../../../enums/CaseNotiFicationEnum";
import {useNavigate} from "react-router-dom";
import ExcelPopup from "../../apiTables/ExcelPopup";
import {FaPlus} from "react-icons/fa";
import {MdClose} from "react-icons/md";

const CreateExpCaseComponent = ({geoIds}) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [data, setData] = useState(null);
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const [regions, setRegions] = useState([]);
    const [cities, setCities] = useState([]);
    const [councils, setCouncils] = useState([]);
    const [populatedAreas, setPopulatedAres] = useState([]);
    const [regionFilter, setRegionFilter] = useState([]);
    const [cityFilter, setCityFilter] = useState([]);
    const [councilFilter, setCouncilFilter] = useState([]);
    const [populatedAreaFilter, setPopulatedAreaFilter] = useState([]);
    const [permitTypes, setPermitTypes] = useState([]);
    const [selectedPermitType, setSelectedPermitType] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [showAlertCadastral, setShowAlertCadastral] = useState(false);
    const [alertInfo, setAlertInfo] = useState({show: false, message: '', type: ''});
    const [cadastralCodeArray, setCadastralCodeArray] = useState([]);
    const [cadastralCode, setCadastralCode] = useState('');
    const [isCadastralCodeLoading, setIsCadastralCodeIsLoading] = useState(false);
    const formatIds = (ids) => ids.map(id => `-${id}-`).join(',');
    const navigate = useNavigate();
    const [alert, setAlert] = useState({message: '', severity: 'info'});

    const fetchCadastralCode = async (cadastralCode) => {
        if (!cadastralCode) {
            return;
        }
        setIsCadastralCodeIsLoading(true);
        try {
            const response = await axios.get(`https://tcsa.gov.ge/api/GetCADCodeByCadastralCode?CadastralCode=${cadastralCode}`);
            if (response.data.success) {
                if (response.data.success) {
                    setCadastralCodeArray(prevArray => {
                        if (!prevArray.includes(cadastralCode)) {
                            setCadastralCode('');
                            setAlert({message: 'ოპერაცია წარმატებით დასრულდა!', severity: 'success'});
                            return [...prevArray, cadastralCode];
                        } else {
                            setAlert({message: 'საკადასტრო კოდი უკვე დამატებულია სიაში!', severity: 'warning'});
                            return prevArray;
                        }
                    });

                } else {
                    setAlert({message: 'საკადასტრო კოდი არ არსებობს!', severity: 'warning'});
                }
            } else if (!response.data.success) {
                const errorMessage = response.data.errors.message || 'საკადასტრო კოდი არასწორია';
                setAlert({message: errorMessage, severity: 'error'});
            } else {
                setAlert({message: 'დაფიქსირდა შეცდომა!', severity: 'error'});
            }
        } catch (error) {
            setAlert({message: 'დაფიქსირდა შეცდომა!', severity: 'error'});
        }
        setIsCadastralCodeIsLoading(false);
        setShowAlertCadastral(true);
    };

    const decodeJwtToken = () => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            try {
                return jwtDecode(token);
            } catch (error) {
                return null;
            }
        }
        return null;
    };

    const buildCaseDetails = (data, caseId) => {
        return Object.keys(data)
            .filter(key => key !== "მისამართი")
            .map(key => ({
                caseDetailInfo: {
                    caseId: caseId,
                    key: key,
                    value: data[key] === null ? "" : String(data[key]),
                    inputType: 0,
                    dictionaryTypeId: null,
                    dictionaryId: null,
                    hasDeadline: false,
                    hasFile: false,
                    unicId: false,
                    visibleOnTable: true,
                    visibleOnTableForUser: true,
                    isIdentificationNumber: false
                }
            }));
    };


    const handlePermitTypeChange = (event) => {
        setSelectedPermitType(event.target.value);
    };


    const handleSubmit = async () => {
        try {
            const payload = {
                settingEndpointKeyWord: 'AddNewCase',
                ipAddress: "123",
                sckipCheck: true,
                permitTypeId: selectedPermitType,
                regionId: formatIds(regionFilter),
                cityId: formatIds(cityFilter),
                councilId: formatIds(councilFilter),
                populatedAreaId: formatIds(populatedAreaFilter),
                objectName: "",
                cadastralCode: cadastralCodeArray.length > 0 ? cadastralCodeArray.join('$') : "",
                address: data['მისამართი'],
                requestedSpeedUp: false,
                finished: false,
                creteByExpert: true,
                acceleration: false,
                permitTypePriceId: null,
                councilRejected: LocationProps.notDeclined,
                populatedAreaRejected: LocationProps.notDeclined,
                regionRejected: LocationProps.notDeclined,
                cityRejected: LocationProps.notDeclined,
                creteByExpertCaseNumber: true,
                caseParentId: null,
                oldCaseNumber: data['უწყებრივ რეესტრში რეგისტრაციის ნომერი'] ? data['უწყებრივ რეესტრში რეგისტრაციის ნომერი'].toString() : null,
                createObjectRegistryID: true,
                objectId: id,
                hasBuilidngDocument: false
            };


            const addNewCaseResponse = await axios.post(`${baseURL}/AddNewCase`, payload);


            if (addNewCaseResponse.data.success && addNewCaseResponse.data.resultId !== undefined) {
                const caseDetailsPayload = {
                    caseDetails: buildCaseDetails(data, parseInt(addNewCaseResponse.data.resultId, 10)),
                };

                const addCaseDetailsResponse = await axios.post(`${baseURL}/AddCaseDetails`, caseDetailsPayload);

                if (addCaseDetailsResponse.data.success) {
                    const decodedToken = decodeJwtToken();
                    if (decodedToken) {

                        const caseNotification = {
                            nextStepUserId: decodedToken.UserId,
                            caseId: parseInt(addNewCaseResponse.data.resultId, 10),
                            documentId: null,
                            action: CaseNotificationEnum.newCaseExpert.id,
                            caseStatus: 8,
                            viewed: false
                        };
                        await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);

                    }

                    navigate(`/dashboard/newcase/uploadfilesexpert?id=${selectedPermitType}&caseid=${addNewCaseResponse.data.resultId}&municipalityId=null&parentId=123`);
                }
            }
            else {
                setShowAlert(true);
                setIsModalOpen(false);
                setAlertInfo({show: true, message: 'დაფიქსირდა შეცდომა', type: 'error'});
            }


        } catch (error) {
            setShowAlert(true);
            setIsModalOpen(false);
            setAlertInfo({show: true, message: 'დაფიქსირდა შეცდომა', type: 'error'});
        }
    };

    const handleDeleteCadastralCode = (codeToDelete) => {
        setCadastralCodeArray((prevArray) => prevArray.filter(code => code !== codeToDelete));
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                const data = response.data;

                const record = data.data.find(item => item.id === 40);
                if (record && record.childrenPermitTypes) {
                    setPermitTypes(record.childrenPermitTypes);
                }
            } catch (error) {
            }
        };

        void fetchData();
    }, []);


    const inputNamesMap = {
        "registraciis_N": "უწყებრივ რეესტრში რეგისტრაციის ნომერი",
        "obieqtis_Dasaxeleba": "ობიექტის დასახელება",
        "saidentifikacio_Nomeri": "საიდენტიფიკაციო მონაცემები",
        "obieqtis_Mflobeli": "ობიექტის მფლობელის დასახელება",
        "obieqtis_Dziritadi_Teqnikuri_Maxasiateblebi": "ობიექტის ძირითადი ტექნიკური მახასიათებლები",
        "raioni": "მისამართი",
        "komentari": "კომენტარი",
        "registraciis_Tarigi": "რეგისტრაციის თარიღი",
        "obieqtis_Mwarmoebeli_Mshenebeli": "ობიექტის მწარმოებელი",
        "chatarebuli_Inspeqtirebis_Tarigi_da_Dargvevis_Gamosworebis_Bolo": "ჩატარებული ინსპეტირევის და თარიღი და დარღვევუს გამოსწორების ბოლო ვადა",
        "informacia_Obieqtze_Momxdari_Avariis_da_Ubeduri_Shemtxvevis_Shesaxeb": "ინფორმაცია ობიექტზე მომხადარი ავარიის და უბედური შემთხვევაში შესახებ",
    };

    useEffect(() => {
        axios.get(`${baseURL}/GetTacsaOldByID?Id=${id}`)
            .then(response => {
                const filteredData = Object.keys(response.data.data)
                    .filter(key => inputNamesMap[key])
                    .reduce((obj, key) => {
                        obj[inputNamesMap[key]] = response.data.data[key];
                        return obj;
                    }, {});
                setData(filteredData);
            })
            .catch(error => console.error('Error fetching data:', error));
    }, [id, baseURL]);


    useEffect(() => {
        const fetchRegions = async () => {
            try {
                const response = await axios.get(`${baseURL}/DictionaryTypesDetalisById?CategoryId=${geoIds.regionId}`);
                if (response.data && response.data.success) {
                    setRegions(response.data.data.resultlist);
                }
            } catch (error) {
            }
        };

        void fetchRegions();
    }, [geoIds]);

    useEffect(() => {
        const fetchCitiesForRegion = async () => {
            if (regionFilter.length > 0 && geoIds) {
                try {

                    const dictionaryRequests = regionFilter.map(regionId => ({
                        dictionaryTypeId: geoIds.municipalityId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setCities(response.data.data);
                    } else {
                        setCities([]);
                    }
                } catch (error) {
                    setCities([]);
                }
            } else {
                setCities([]);
            }
        };

        void fetchCitiesForRegion();
    }, [regionFilter, geoIds]);


    useEffect(() => {
        const fetchCouncisForCities = async () => {
            if (cityFilter.length > 0 && geoIds) {
                try {
                    const dictionaryRequests = cityFilter.map(regionId => ({
                        dictionaryTypeId: geoIds.councilId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setCouncils(response.data.data);
                    } else {
                        setCouncils([]);
                    }
                } catch (error) {
                    setCouncils([]);
                }
            } else {
                setCouncils([]);
            }
        };
        void fetchCouncisForCities();
    }, [cityFilter, geoIds]);


    useEffect(() => {
        const fetchPopulatedAreasForCouncils = async () => {
            if (councilFilter.length > 0 && geoIds) {
                try {

                    const dictionaryRequests = councilFilter.map(regionId => ({
                        dictionaryTypeId: geoIds.cityId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setPopulatedAres(response.data.data);
                    } else {
                        setPopulatedAres([]);
                    }
                } catch (error) {
                    setPopulatedAres([]);
                }
            } else {
                setPopulatedAres([]);
            }
        };
        void fetchPopulatedAreasForCouncils();
    }, [councilFilter, geoIds]);


    const handleRegionChange = (event) => {
        const newValue = event.target.value;
        setRegionFilter(newValue);


        if (newValue.length > 0) {
            const fetchCitiesForRegions = async () => {
                try {
                    const dictionaryRequests = newValue.map(regionId => ({
                        dictionaryTypeId: geoIds.municipalityId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setCities(response.data.data);
                    } else {
                        setCities([]);
                    }
                } catch (error) {
                    setCities([]);
                }
            };

            void fetchCitiesForRegions();
        } else {
            setCities([]);
        }
    };

    const handleCityChange = (event) => {
        const newValue = event.target.value;
        setCityFilter(newValue);

        if (newValue.length > 0) {
            const fetchCouncilsForCities = async () => {
                try {
                    const dictionaryRequests = newValue.map(regionId => ({
                        dictionaryTypeId: geoIds.councilId,
                        dictionaryId: regionId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data && response.data.success) {
                        setCouncils(response.data.data);
                    } else {
                        setCouncils([]);
                    }
                } catch (error) {
                    setCouncils([]);
                }
            };

            void fetchCouncilsForCities();
        } else {
            setCouncils([]);
        }
    };



    if (!data) {
        return <div className="old-objects-loader"><CircularProgress/></div>;
    }

    return (
        <div className="create-expedite-case-container">
            <div className="old-objects-title">ობიექტის რეგისტრაცია</div>
            <ExcelPopup isVisible={isCadastralCodeLoading}
                        loaderText={"მიმდინარეობს საკადასტრო კოდის ვერიფიკაცია"}
                        loaderType={"CadastralCode"}/>
            <Container maxWidth="md">


                <Grid container spacing={2}>
                    <FormControl fullWidth style={{marginBottom: 20, marginTop: 20}}>
                        <InputLabel>ობიექტი</InputLabel>
                        <Select
                            value={selectedPermitType}
                            label="ობიექტი"
                            onChange={handlePermitTypeChange}
                        >
                            {permitTypes.map((permitType) => (
                                <MenuItem key={permitType.id} value={permitType.id}>
                                    {permitType.title}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl style={{marginBottom: 20}} fullWidth>
                        <InputLabel>რეგიონი</InputLabel>
                        <Select
                            multiple
                            value={regionFilter}
                            label="რეგიონი"
                            onChange={handleRegionChange}
                            renderValue={(selected) => selected.map((id) => regions.find(region => region.id === id)?.itemName).join(', ')}
                        >
                            {regions.map((region) => (
                                <MenuItem key={region.id} value={region.id}>
                                    {region.itemName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl style={{marginBottom: 20}} fullWidth disabled={regionFilter.length === 0}>
                        <InputLabel>მუნიციპალიტეტი</InputLabel>
                        <Select
                            multiple
                            value={cityFilter}
                            label="მუნიციპალიტეტი"
                            onChange={handleCityChange}
                            renderValue={(selected) => selected.map((id) => cities.find(region => region.id === id)?.typesName).join(', ')}

                        >
                            {cities.map((city) => (
                                <MenuItem key={city.id} value={city.id}>
                                    {city.typesName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Grid container alignItems="center" spacing={1} style={{ marginBottom: 20, width: 868 }}>
                        <Grid item xs>
                            <TextField
                                fullWidth
                                variant="outlined"
                                value={cadastralCode}
                                placeholder={"საკადასტრო კოდი"}
                                onChange={(e) => setCadastralCode(e.target.value)}
                            />
                        </Grid>
                        <Grid item>
                            <Tooltip title={cadastralCode === "" ? "გთხოვთ შეიყვანოთ საკადასტრო კოდი" : "საკადასტრო კოდის დამატება"}>
                                <div>
                                    <FaPlus
                                        onClick={() => fetchCadastralCode(cadastralCode)}
                                        style={{
                                            cursor: cadastralCode === "" ? "not-allowed" : "pointer",
                                            color: cadastralCode === "" ? "#ccc" : "#0e5bd0",
                                            fontSize: 24
                                        }}
                                    />
                                </div>
                            </Tooltip>
                        </Grid>
                    </Grid>


                    {cadastralCodeArray.length > 0 && (
                        <>
                            <label className="label-font">არჩეული საკადასტრო კოდები:</label>
                            <div className="casecreate-chips-container-expert">
                                {cadastralCodeArray.map((code, index) => (
                                    <Chip
                                        key={index}
                                        label={code}
                                        onDelete={() => handleDeleteCadastralCode(code)}
                                        deleteIcon={<MdClose/>}
                                        className="casecreate-chips-chip"
                                    />
                                ))}
                            </div>
                        </>
                    )}


                    {Object.keys(data).filter(key => key !== "უწყებრივ რეესტრში რეგისტრაციის ნომერი").map((key) => (
                        <Grid fullWidth>
                            <TextField
                                style={{width: 868, marginBottom: 20}}
                                fullWidth
                                label={key}
                                variant="outlined"
                                value={data[key] || ''}
                                onChange={(event) => setData({...data, [key]: event.target.value})}
                            />
                        </Grid>
                    ))}

                </Grid>
                <Tooltip title={selectedPermitType === "" ? "გთხოვთ აირჩიოთ ობიექტი!" : ""}>
                    <span style={{cursor: selectedPermitType === "" ? "not-allowed" : "pointer"}}>
                        <Button onClick={() => setIsModalOpen(true)}
                                fullWidth
                                disabled={selectedPermitType === ""}
                                variant="contained"
                                color="primary"
                                style={{marginTop: 20, marginBottom: 30}}
                        >
                            გაგზავნა
                        </Button>
                    </span>
                </Tooltip>


            </Container>
            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={handleSubmit}
            />
            {showAlert && (
                <CustomAlert
                    message={alertInfo.message}
                    type={alertInfo.type}
                    onClose={() => {
                        setShowAlert(false);
                        setAlertInfo({...alertInfo, show: false});
                    }}
                    severity={alertInfo.type}
                />
            )}

        </div>
    );
};

export default CreateExpCaseComponent;
